import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import {ServerTable, ClientTable} from 'vue-tables-2';
Vue.use(ClientTable);
import VueNotifications from 'vue-notifications';
import miniToastr from 'mini-toastr'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import moment from 'moment-timezone'

library.add(fas)
library.add(far)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false


import constants from '../config/constants';
const toastTypes = {
  	success: 'success',
  	error: 'error',
  	info: 'info',
  	warn: 'warn'
}
miniToastr.init({types: toastTypes})
function toast ({title, message, type, timeout, cb}) {
  	return miniToastr[type](message, title, timeout, cb)
}
const options = {
  	success: toast,
  	error: toast,
  	info: toast,
  	warn: toast
}
Vue.use(VueNotifications, options)

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)

Vue.prototype.$moment = moment;
Vue.filter('momentDate', function (value) {
if (value && value !== 'N/A') {
return moment(value).tz(TIMEZONE).format('MM-DD-YYYY HH:mm')
} else {
    return value;
 }
});

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
